export const h = {	
	login:{		
			login:"Giriş yapmak",
			pleaseusername:"lütfen kullanıcı adını girin",
			pleasepassword:"Lütfen şifre giriniz",
			checkname:"Lütfen doğru kullanıcı adını girin",
			checkpass:"Şifre 3 karakterden az olamaz",
		},	

	navbar:{	
		home:"ön Sayfa",
		mycenter:"Kişisel Merkez",
		outlogin:"çıkış yapmak",
		close:"kapanış",
		editLanguage:"düzenleme dili",
	},	
	vip:{	
		nickname:"Takma ad",
		pleasenickname:"Lütfen bir takma isim giriniz",
		username:"Kullanıcı adı",
		pleaseusername:"lütfen kullanıcı adını girin",
		arealogin:"Giriş alanı",
		pleasearealogin:"Lütfen giriş alanınızı girin",
		nationality:"Uyruğu Olunan Ülke",
		pleasenationality:"Lütfen uyruğu seçin",
		depositstatus:"Para yatırma durumu",
		pleasedepositstatus:"Lütfen para yatırma durumunu seçin",
		createtime:"yaratılış zamanı",
		logintime:"Oturum açma zamanı",
		startime:"Başlangıç zamanı",
		endtime:"Bitiş zamanı",
		no:"seri numarası",
		shangji:"Üstlere doğrudan tavsiye",
		keyongmoney:"Kalan bakiye",
		baozhengjing:"marj",
		fudongyingkui:"Değişken kar ve zarar",
		zicantotal:"Toplam varlıklar",
		yaoqingma:"Davet Kodu",
		zongrujing:"toplam mevduat",
		zongchujing:"Toplam para çekme",
		loginIp:"giriş IP'si",
		zuihoulogin:"son giriş zamanı",
		shoucirujingmoney:"İlk para yatırma tutarı",
		shoucirujingtime:"İlk para yatırma zamanı",
		kaitongtime:"Açılış zamanı",
		keyong:"Mevcut",
		daoshi:"özel öğretmen",
		dongjie:"donmak",
		chujingstate:"Para çekme durumu",
		xiajichujingstate:"Düşük seviye para çekme durumu",
		caozuo:"işletmek",
		chakan:"Kontrol etmek",
		heji:"Toplam",
		moneytotal:"toplam bakiye",
		paixu:"düzenlemek",
		daochu:"İhracat",
		huiyuanguanli:"Üye yönetimi",
		yonghu:"kullanıcı",
		search:"Sorgu arama",
		reset:"Sıfırla",
		delete:"silmek",
		kickout:"kovmak",
		notlogin:"Giriş yapmadınız",
		editLanguage:"düzenleme dili",
		yourujing:"Depozito var",
		wurujing:"Depozito yok",
    todayreg: "Bugünün kayıt hacmi: ",
    newvipnum: "Katılan yeni VIP üye sayısı: ",
    juese: "rol",
    xiugaimima: "şifre değiştir",
    jiumima: "eski şifre",
    shurujiumima: "lütfen eski şifrenizi girin",
    xinmima: "yeni şifre",
    shuruxinmima: "lütfen yeni şifrenizi girin",
    gerenzhongxing: "kişisel merkezi",
    yonghuxinxi: "kullanıcı bilgisi"
	},	
	info:{	
		home:"Ana sayfa",
		user:"Kullanıcı kimliği",
		nickname:"Takma ad",
		account:"hesap",
		identity:"kimlik Numarası",
		phone:"telefon numarası",
		nationality:"Uyruğu Olunan Ülke",
		Balance:"Bakiye yönetimi",
		real:"gerçek hesap",
		zhongmongy:"toplam bakiye",
		keyongmoney:"Kalan bakiye",
		jiaoyidongjie:"İşlem donduruldu",
		shishilirun:"gerçek zamanlı kar",
		shishikeyong:"Gerçek zamanlı olarak kullanılabilir",
		xunizhanghu:"sanal hesap",
		churujinguanli:"Para yatırma ve çekme yönetimi",
		chakanzijinjilu:"Fon geçmişini görüntüle",
		rujinjilu:"Mevduat kaydı",
		rujinjine:"Mevduat tutarı",
		jiaoyibishu:"İşlem sayısı",
		chujinjilu:"Para çekme kayıtları",
		chujinjine:"Para çekme tutarı",
		jiaoyiguanli:"İşlem yönetimi",
		lishijilu:"geçmiş kaydı",
		chakanlishi:"Geçmiş işlem bilgilerini görüntüle",
		jiaoyishoushu:"Ticaret lotları",
		jiaoyiyingkui:"Ticari kar ve zarar",
		dangqianchicang:"Şu anki pozisyon",
		chakandangqianchicang:"Mevcut konum bilgisini görüntüle",
		dangqianguadan:"Mevcut bekleyen sipariş",
		chakanguadanliebiao:"Bekleyen sipariş listesini görüntüle",
		guadanbishu:"Bekleyen siparişlerin sayısı",
		yongjinguanli:"Komisyon yönetimi",
		duanwei:"rütbe",
		wu:"hiçbiri",
		zhishushangji:"Acil amir",
		shangjidaili:"Üstün temsilci",
		xiajituandui:"Alt ekip",
		shurudailiname:"Lütfen temsilci adını girin",
		chakan:"Kontrol etmek",
		fanyongjie:"İndirim tutarı",
		fanyongbishu:"İndirim sayısı",
		chakanyongjinjilu:"İndirim kayıtlarını görüntüle",
		chakanyonghuinfo:"Kullanıcı ayrıntılarını görüntüle",
		chakanwenjuan:"Anketi görüntüle",
		resetpassword:"şifreyi yenile",
		sendmsg:"mesaj gönder",
		update:"Tekrar düzeltme yapmak",
		unbound:"Bağlı değil",
		weishiming:"Gerçek ad kimlik doğrulaması yok",
		gendan:"Dokümantasyon yönetimi",
		gensui:"takip etmek",
		chakangendan:"Sipariş kayıtlarını görüntüle",
		dingdanhao:"sipariş numarası",
		shoudongpay:"Manuel şarj",
		chakanyongjingjilu:"Komisyon geçmişini görüntüle",
		xiugaiyonghuxinxi:"Kullanıcı bilgilerini değiştirin",
		queding:"Elbette",
		quxiao:"İptal etmek",
		email:"Posta",
		selguoji:"Lütfen uyruğu seçin",
		sendusermsg:"Kullanıcıya mesaj gönder",
		title:"başlık",
		shurutitle:"Lütfen mesaj başlığını girin",
		content:"içerik",
		shurucontent:"Lütfen mesaj içeriğini girin",
		zhenshi:"gerçeklik",
		xuni:"sanal",
		fangxiang:"yön",
		zhanghu:"Hesap",
		add:"Arttırmak",
		less:"kesinti",
		type:"tip",
		guanliyuanpay:"Yönetici şarjı",
		pay:"tamamlamak",
		money:"Miktar",
		updategdmsg:"Sipariş bilgilerini değiştir",
		xinhaoyuan:"sinyal kaynağı",
		yes:"Evet",
		no:"HAYIR",
		updateyongjingmsg:"Komisyon bilgilerini değiştirin",
		qingxuanzejuese:"Lütfen hesap rolünü seçin",
		zuoduo:"Uzun git",
		zuokong:"kısa",
		gensuinicheng:"takma adı takip et",
		kaicangjia:"açılış fiyatı",
		pingcangjia:"Kapanış fiyatı",
		shousu:"Lot büyüklüğü",
		pingcangdate:"Pozisyon açılış tarihi",
		kaicangdate:"Kapanış tarihi",
		chakangensuiinfo:"Takip ayrıntılarını görüntüle",
		gensuiuserno:"Kullanıcı numarasını takip et",
		gensuiyonghuname:"Kullanıcı takma adını takip et",
		gensuifangshji:"yöntemi takip et",
		number:"miktar",
		danwei:"birim",
		zhengxiang:"ileri",
		fanxaing:"tersi",
		beishu:"çoklu",
		shousu:"Lot büyüklüğü",
		gensuizhuangtai:"durumu takip et",
		genjinzhong:"Uygulama takip ediliyor",
		gensuiok:"Takip edilmeyi kabul ediyorum",
		gensuino:"Takip edilmeyi reddetti",
		chexiao:"İptal etmek",
		gensuidate:"takip zamanı",
		chakanlishijiaoyi:"Geçmiş işlem bilgilerini görüntüle",
		chakanguadanlist:"Bekleyen sipariş listesini görüntüle",
		heyue:"sözleşme",
		daili:"oyunculuk",
		huiyuanname:"Üyenin adı",
		xianjia:"fiyat sınırı",
		zhisun:"kaybı durdurmak",
		guadanjia:"bekleyen sipariş fiyatı",
		zhiyingzhisun:"Kâr alın ve zararı durdurun",
		zhiyingjia:"Kâr fiyatını al",
		zhiyinghuichejia:"Kâr geri çekilme fiyatını al",
		zhisunjia:"Zararı durdurma fiyatı",
		zhisunhuichejia:"Zararı durdurma geri alma fiyatı",
		weiset:"ayarlanmamış",
		zt:"durum",
		chakanchicangmsg:"Mevcut konum bilgisini görüntüle",
		shouyiId:"Faydalanıcı Kimliği",
		xiajiid:"Alt kullanıcı kimliği",
		xiajiuser:"Alt kullanıcı adı",
		fanyongmonney:"İndirim tutarı",
		tuihuibaozhengjing:"İade depozitosu",
		shouxufei:"Hizmet bedeli",
		shouyi:"gelir",
		lixi:"Faiz",
		zengmoney:"bonus",
		zhuijiabaozhengjing:"marj çağrısı",
		fanyong:"İndirim",
		rujing:"Depozito",
		chujing:"Para çekme",
		chujingshibai:"Para çekme incelemesi başarısız olursa para iadesi",
		guanliyuanless:"Yönetici kesintisi",
		pingzhong:"Çeşitlilik",
		shengqingzhong:"Başvuruyor",
		wancheng:"Sona ermek",
		chongzhimima:"Şifre sıfırlama başarılı",
		copy:"kopyala",
		zhanghaomima:"hesap şifresi",
		fenye:"Makale / Sayfa",
    tixianmima:"Parola çıkartma",
		gong:"yaygın",
		tiao:"şerit",
		ye:"Sayfa",
		goto:"Git",
		outtitle:"Çıkış yaptınız. İptal edip bu sayfada kalabilir veya tekrar giriş yapabilirsiniz.",
		outok:"Oturumu kapatmak için tamam",
		chongxingdenglu:"yeniden kayıt ol",
		cancel:"İptal etmek",
		pingtai:"platformu",
		nodata:"Veri yok",
    shangjiID: "Üst ID",
    shangjiaccount: "Üst Hesap",
    shangjiname: "Üst Takma Ad",
    shangjinickname: "Üst Ad",
    zhongyingkui: "Toplam Kâr ve Zarar",
    fuying: "Dalgalanma Kâr",
    yue: "Bakiye",
    sheng: "Artan Sıra",
    jiang: "Azalan Sıra"

	},	
	history:{		
			guadan:"Kar ve zarar",
			shijia:"bekleyen sipariş",
			gendan:"Market fiyatı",
			dangqianjia:"Siparişleri takip edin",
			geyelixi:"Mevcut fiyat",
			weituodate:"gecelik faiz",
			pingcangfangshi:"Komisyon süresi",
			dingdanyongjing:"Kapanış yöntemi",
			shoudongpingcang:"Sipariş komisyonu",
			qiangzhipingcang:"Manuel kapatma",
			gendanpingcang:"Zorla tasfiye",
			baocang:"Tasfiye",
			yuguqiangpingjia:"Bir pozisyonu kapatmak için emirleri takip edin",
			kaicangdiqu:"Tahmini zorunlu parite fiyatı",
			ispingcang:"Açılış alanı",
			tips:"Zorunlu tasfiye konusunda emin misiniz?",
			pincangsucc:"ipucu",
			queding:"Pozisyon başarıyla kapatıldı",
			cancel:"Elbette",
		},	
	Langswitch: {	
	  "en":"İngilizce",	
	  "id":"Endonezya dili",	
	  "th":"Tayland dili",	
	  "vi":"Vietnam",	
	  "zh":"Çince",	
	  "fa":"Fransızca",	
	  "han":"Koreli",	
	  "tu":"Türkçe",	
	  "pu":"Portekizce",	
	  "xi":"İspanyol",	
	  "jp":"Japonca",	
	  "ar":"Arapça",	
	},	
}		



// WEBPACK FOOTER //
// ./src/i18n/langs/tu.js